/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2017/11/9 10:38
 * @desc
 */

import axios from 'axios'
import { ReactNode, useEffect, useState, useCallback } from 'react'
import { LangProvider, UserInfoProvider } from '../HOC'
import OnLineService from '../OnLineService'
import LayoutFooter from './LayoutFooter/LayoutFooter'
import LayoutHeader from './LayoutHeader/LayoutHeader'

if (window.PRERENDER) {
  axios.interceptors.request.use(() => Promise.reject('预渲染环境，不访问接口'))
}

interface PropTypes {
  lang: Lang
  activeHref?: string
  children: ReactNode
  className?: string
  headerFixed?: boolean
  headerVisible?: boolean
  i18nVisible?: boolean
  footerVisible?: boolean
  hasSetupAxios?: boolean
  isUserInfoOptional?: boolean // 部分页面需免登录访问
}

export default function (props: PropTypes) {
  const {
    className,
    lang,
    activeHref,
    children,
    headerFixed = true,
    headerVisible = true,
    footerVisible = true,
    i18nVisible = true,
    hasSetupAxios = false,
    isUserInfoOptional,
  } = props

  const [userInfo, setUserInfo] = useState(undefined)
  const [flag, setFlag] = useState(false)

  // 获取用户信息
  const fetchUserInfo = useCallback(() => {
    axios
      .post(`${BD_API}/seller/account/query-by-token`)
      .then(res => {
        if (res.data.code === 0) {
          setUserInfo(res.data.data)
        } else if (hasSetupAxios && res.code === 0) {
          setUserInfo(res.data)
        }
      })
  }, [hasSetupAxios])

  const changeFlag = (value: boolean) => {
    setFlag(value)
  }

  useEffect(() => {
    if (!isUserInfoOptional) fetchUserInfo()
  }, [isUserInfoOptional, fetchUserInfo])

  return (
    <div className={className}>
      {
        // @ts-ignore
        <UserInfoProvider value={{ userInfo }}>
          <LangProvider value={{ lang }}>
            {
              headerVisible &&
              <LayoutHeader
                lang={lang}
                userInfo={userInfo}
                activeHref={activeHref}
                i18nVisible={i18nVisible}
                fixed={headerFixed}
              />
            }

            {children}
            {footerVisible && <LayoutFooter lang={lang} />}

            <OnLineService
              userInfo={userInfo}
              flag={flag}
              lang={lang}
              changeFlag={changeFlag}
            />
          </LangProvider>
        </UserInfoProvider>
      }
    </div>
  )
}
